import React from 'react';
import { ApolloProvider, gql, useQuery } from '@apollo/client';
import client from '../lib/apolloClient';
import AssessmentPromptEmptyState from '../components/Succession/AssessmentPromptEmptyState';
import { shouldShowAssessmentPrompt } from '../utils/unifiedIntake';

const GET_USER = gql`
  query GetUserForPrompt { getCurrentUser { id triggering_events { event_type completed_at } } }
`;

const Inner = ({ placement }) => {
  const { data } = useQuery(GET_USER, { fetchPolicy: 'network-only' });
  const user = data?.getCurrentUser || null;
  const show = shouldShowAssessmentPrompt(user);
  return (
    <div className="p-6">
      {show ? <AssessmentPromptEmptyState placement={placement} /> : null}
    </div>
  );
};

const AssessmentPromptPage = (props) => (
  <ApolloProvider client={client}>
    <Inner placement={props.placement || 'map_or_sprint'} />
  </ApolloProvider>
);

export default AssessmentPromptPage;


